export default __webpack_public_path__ + "static/media/logo.db1488bd.png";